import React from "react";
import style from "./style.module.scss";
import { TOTAL_WHITELIST } from "@/constants/whitelist";

const MintInfo: React.FC = () => {
  return (
    <div className={style.wrapper}>
      <div className={style.background}>
        <img src="/images/mint-bg.png" alt="" />
      </div>
      <div className={style.infoWrapper}>
        <div className={style.heading}>
          <h2 className={style.title}>Mint Overview</h2>
          <p className={style.desc}>
            Welcome to the official mint for Warplet Mutants: Aftershock
          </p>
        </div>
        <div className={style.content}>
          <div className={style.paraWrapper}>
            <h3 className={style.subTitle}>
              1. Whitelist Model: (FCFS First-Come, First-Served)
            </h3>
            <ul className={style.list}>
              <li className={style.item}>
                <p className={style.text}>
                  A total of {TOTAL_WHITELIST} whitelist spots will be available
                  for registration.
                </p>
              </li>
              <li className={style.item}>
                <p className={style.text}>
                  This is an FCFS Whitelist, meaning only the earliest users to
                  arrive at mint time will successfully mint.
                </p>
              </li>
              <li className={style.item}>
                <p className={style.text}>
                  Being whitelisted does not guarantee a mint — it simply grants
                  access to compete in the first-come mint window.
                </p>
              </li>
            </ul>
          </div>
          <div className={style.paraWrapper}>
            <h3 className={style.subTitle}>
              2. Whitelist Registration & Countdown Users can register for a
              whitelist spot directly on the site.
            </h3>
            <ul className={style.list}>
              <li className={style.item}>
                <p className={style.text}>
                  Users can register for a whitelist spot directly on the site.
                </p>
              </li>
              <li className={style.item}>
                <p className={style.text}>
                  A real-time countdown timer will display the exact moment the
                  mint opens, allowing all participants to prepare in advance.
                </p>
              </li>
            </ul>
          </div>
          <div className={style.paraWrapper}>
            <h3 className={style.subTitle}>3. Mint Details</h3>
            <ul className={style.list}>
              <li className={style.item}>
                <p className={style.text}>Mint Price: Free Mint</p>
              </li>
              <li className={style.item}>
                <p className={style.text}>Mint Limit: 1 per wallet</p>
              </li>
              <li className={style.item}>
                <p className={style.text}>
                  Eligibility: Exclusive to approved Farcaster accounts
                </p>
              </li>
              <li className={style.item}>
                <p className={style.text}>
                  Minting Method: FCFS through whitelist access
                </p>
              </li>
            </ul>
          </div>
          <div className={style.paraWrapper}>
            <h3 className={style.subTitle}>4. Post-Mint Trading</h3>
            <p className={style.text}>
              After the mint concludes, all secondary trading will take place on
              OpenSea, where collectors can buy, sell, and trade Warplet Mutants
              on an open marketplace.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MintInfo;
